import { createAsyncThunk } from '@reduxjs/toolkit';
import LocalStorageService from '../common/local-storage-service';
import { getErrorPayload } from '../../helpers/api-helper';
import AuthApi from '../../../infrastructure/auth-api';
export const loginAsync = createAsyncThunk('auth/login', async (_, { rejectWithValue, fulfillWithValue }) => {
    try {
        const response = await AuthApi.login();
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const refreshTokenAsync = createAsyncThunk('auth/refreshToken', async (_, { rejectWithValue }) => {
    try {
        const refreshTokenRequest = {
            accessToken: LocalStorageService.getAccessToken(),
            refreshToken: LocalStorageService.getRefreshToken()
        };
        const response = await AuthApi.getRefreshToken(refreshTokenRequest);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const verifyTokenAsync = createAsyncThunk('auth/verifyToken', async (VerifyTokenDto, { rejectWithValue, fulfillWithValue }) => {
    try {
        const response = await AuthApi.verifyToken(VerifyTokenDto);
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
